import { Capacitor } from "@capacitor/core";
import axios from "axios";

// On native platforms (iOS/Android), the app loads from bundled assets
// so relative API calls (e.g. /api/v1/...) won't resolve without a base URL.
// On web, relative URLs work via the proxy (dev) or same-origin (production).
// Exported so non-axios callers (e.g. Browser.open for OAuth) can build
// absolute URLs too — a relative URL there silently fails on native.
export const API_BASE_URL = "https://app.sastiride.com";

// CSRF defense: send a custom header on every request. A cross-site form/img
// can't set it, and cross-origin attempts are blocked by the server's CORS
// allowlist. The server requires this header on all mutating /api requests.
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

if (Capacitor.isNativePlatform()) {
  axios.defaults.baseURL = API_BASE_URL;
  axios.defaults.withCredentials = true;
}
